import actionCreatorFactory from 'typescript-fsa';

/**
 * コンテンツ配信画面の研修一覧情報
 */
export interface ISearchListItem {
	careerId: string;
	careerTitle: string;
}
const actionCreator = actionCreatorFactory();

/** コンテンツ配信画面の検索アクションクリエータ */
export const setSearchList = actionCreator<{
	data: ISearchListItem[];
}>('SET_SEARCH_LIST');

/**
 * ログファイルを取得する用
 */
export const setLogFile = actionCreator<{
	result: string;
}>('SET_QUICK_MODE_ASSIGN_STUDENT_LOG');

/**
 * テンプレートのダウンロード押下用
 */
export const setExcelFile = actionCreator<{
	excelResult: string;
}>('SET_QUICK_MODE_EXCEL_DATA');



// WEBPACK FOOTER //
// ./src/actions/quickModeStudentAssign.ts